import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBag } from 'lucide-react';
export function HeroSection() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative flex items-center px-5 md:px-10 lg:px-16 pt-8 md:pt-12 overflow-hidden min-h-screen lg:min-h-[700px]" data-id="element-134" data-mp="28uxs5ijhxu0x">
      <div className="absolute inset-0" data-id="element-135" data-mp="2wm35nr1ysa82">
        <img src="https://cdn.magicpatterns.com/uploads/uUpuPt3gbZ7V5QdrqJgFQx/heylloyd-image-1782595699976.png" alt="Familia feliz y diversa con niños" className="w-full h-full object-cover" data-id="element-136" data-mp="30k96yjk19xll" />
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(135deg, rgba(20, 80, 20, 0.65) 0%, rgba(0, 60, 10, 0.50) 50%, rgba(0, 40, 0, 0.40) 100%)'
      }} data-id="element-137" data-mp="2rr5ykpo8waxt" />
      </div>

      <div className="relative max-w-5xl mx-auto text-center w-full pt-12 pb-20" data-id="element-138" data-mp="2ff0j76y73bmv">
        <img src="https://cdn.magicpatterns.com/uploads/4XjcpcjWQEZca1XxaXZTTT/pancita_feliz.png" alt="Pancita Feliz Foundation" className="animate-fade-in-down mx-auto mb-6" style={{
        width: '320px',
        height: 'auto',
        objectFit: 'contain',
        mixBlendMode: 'luminosity',
        filter: 'brightness(0) invert(1)',
        opacity: 0.95
      }} data-id="element-139" data-mp="2be6uibcxhssx" />

        <div className="flex items-center justify-center" style={{
        gap: '12px',
        marginBottom: '20px'
      }} data-id="element-140" data-mp="2u3wncsx4s4i7">
          <span style={{
          display: 'inline-block',
          width: '40px',
          height: '2px',
          background: '#7DC920',
          opacity: 0.8,
          verticalAlign: 'middle'
        }} data-id="element-141" data-mp="334uvnnelqy6l" />
          <span className="text-xs md:text-sm font-bold tracking-widest uppercase" style={{
          color: '#7DC920',
          textShadow: '0 0 20px rgba(125, 201, 32, 0.6)'
        }} data-id="element-142" data-mp="38tb8dlwntwlc">
            Descubre • Conecta • Evoluciona
          </span>
          <span style={{
          display: 'inline-block',
          width: '40px',
          height: '2px',
          background: '#7DC920',
          opacity: 0.8,
          verticalAlign: 'middle'
        }} data-id="element-143" data-mp="3itvb6sztv95o" />
        </div>

        <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight drop-shadow-lg mx-auto max-w-4xl" data-id="element-144" data-mp="k1i5r7vxq5v">
          Transformamos la biología familiar para cambiar el futuro del
          neurodesarrollo
        </h1>

        <p className="text-sm md:text-base lg:text-lg text-white opacity-90 mb-10 max-w-3xl mx-auto drop-shadow" data-id="element-145" data-mp="edsvlaoqlu6v">
          Cada semana, familias con niños neurodiversos no pueden acceder a
          terapias, evaluaciones o educación especializada por razones
          económicas. Tu donación cambia eso.
        </p>

        <div className="mp-hero-btns flex flex-col sm:flex-row items-center justify-center flex-wrap gap-4" data-id="element-146" data-mp="1yua47cwi0fva">
          <Link to="/solicitar-ayuda" className="mp-hero-ghost-btn mp-hero-btn w-full sm:w-auto inline-flex items-center justify-center text-center transition-colors" style={{
          background: 'transparent',
          color: 'white',
          border: '2px solid rgba(255,255,255,0.7)',
          padding: '16px 32px',
          borderRadius: '10px',
          fontSize: '16px',
          fontWeight: 600,
          textDecoration: 'none'
        }} data-id="element-147" data-mp="1uuj9iy3upflh">
            Solicitar Ayuda
          </Link>
          <Link to="/donar" className="mp-hero-btn w-full sm:w-auto inline-flex items-center justify-center text-center transition-transform" style={{
          background: 'linear-gradient(135deg, #7DC920 0%, #5fa010 100%)',
          color: 'white',
          fontWeight: 700,
          padding: '16px 36px',
          borderRadius: '10px',
          fontSize: '16px',
          border: 'none',
          boxShadow: '0 4px 20px rgba(125,201,32,0.4)',
          textDecoration: 'none'
        }} data-id="element-148" data-mp="369yfgre1fhsq">
            Donar Ahora
          </Link>
          <Link to="/tienda" className="mp-hero-ghost-btn mp-hero-btn w-full sm:w-auto inline-flex items-center justify-center gap-2 text-center transition-colors" style={{
          background: 'transparent',
          color: 'white',
          border: '2px solid rgba(255,255,255,0.7)',
          padding: '16px 32px',
          borderRadius: '10px',
          fontSize: '16px',
          fontWeight: 600,
          textDecoration: 'none'
        }} data-id="element-149" data-mp="34r6h5lwyzvvj">
            <ShoppingBag size={18} data-id="element-150" data-mp="5pn6bl8pgs73" />
            Tienda
          </Link>
        </div>
      </div>
    </section>;
}